import { render, staticRenderFns } from "./importLogList.vue?vue&type=template&id=06cb370e"
import script from "./importLogList.vue?vue&type=script&lang=js"
export * from "./importLogList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports